<script>
export default {
	name: '',
	props: {
		color1: {
			type: String,
			default: '#2954C8',
		},
		color2: {
			type: String,
			default: '#157FEE',
		},
		color3: {
			type: String,
			default: '#DFF4FF',
		},
	},
}
</script>

<template>
	<svg class="anim-circle" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask
			id="mask0_4004_11119"
			style="mask-type: alpha"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="47"
			height="47"
		>
			<circle cx="23.5" cy="23.5" r="23.5" fill="#D9D9D9" />
		</mask>
		<g mask="url(#mask0_4004_11119)">
			<path
				id="top-1"
				d="M-9 16.5945L-5.60687 16.2937C-2.21375 15.9821 4.5725 15.3805 11.3435 17.9052C18.1221 20.4298 24.8779 26.0807 31.6565 24.9527C38.4275 23.8246 45.2138 15.9177 48.6069 11.9535L52 8V46.9976C39.2266 46.9976 26.4524 46.9976 13.679 46.9976C7.29234 46.9976 0.905638 46.9976 -5.48182 46.9976C-5.74412 46.9976 -9 47.0083 -9 46.9847C-9 46.7634 -9 46.5421 -9 46.3218C-9 45.1132 -9 43.9035 -9 42.6949C-9 33.9941 -9 25.2943 -9 16.5945Z"
				:fill="color1"
			/>
			<path
				id="top-2"
				d="M0 19L2.67 20.3581C5.34 21.7116 10.68 24.4279 16.008 25.0465C21.342 25.6651 26.658 24.1953 31.992 24.0465C37.32 23.8977 42.66 25.0791 45.33 25.6651L48 26.2558V31C32.4204 31 16.8408 31 1.2606 31C0.8406 31 0.42 31 0 31L0 19Z"
				:fill="color2"
			/>
			<path
				id="top-3"
				d="M-9 28.3561L-3.38188 29.1731C2.23625 29.9728 13.4725 31.6069 24.6835 29.486C35.9071 27.3652 47.0929 21.5241 58.3165 20.2725C69.5275 19.0208 80.7637 22.3933 86.3819 24.0622L92 25.7484V48C59.2179 48 26.4359 48 -6.34749 48C-7.23124 48 -8.11625 48 -9 48L-9 28.3561Z"
				:fill="color3"
			/>
		</g>
	</svg>
</template>

<style>
.anim-circle {
	flex-shrink: 0;
}

.rating path {
	transition: 0.7s ease-in-out;
}
.rating:hover #top-1 {
	d: path(
		'M-2 11.1371L1.39313 10.7823C4.78625 10.4148 11.5725 9.70524 18.3435 12.683C25.1221 15.6608 31.8779 22.3259 38.6565 20.9954C45.4275 19.6649 52.2138 10.3388 55.6069 5.66307L59 1V46.9971C46.2266 46.9971 33.4524 46.9971 20.679 46.9971C14.2923 46.9971 7.90564 46.9971 1.51818 46.9971C1.25588 46.9971 -2 47.0098 -2 46.9819C-2 46.7209 -2 46.4599 -2 46.2001C-2 44.7746 -2 43.3478 -2 41.9222C-2 31.6597 -2 21.3984 -2 11.1371Z'
	);
}
.rating :hover #top-2 {
	d: path(
		'M-12 11L-9.33 13.1504C-6.66 15.2934 -1.32 19.5942 4.008 20.5736C9.342 21.5531 14.658 19.226 19.992 18.9903C25.32 18.7547 30.66 20.6252 33.33 21.5531L36 22.4884V30C20.4204 30 4.8408 30 -10.7394 30C-11.1594 30 -11.58 30 -12 31L0 19Z'
	);
}
.rating:hover #top-3 {
	d: path(
		'M-28 24.4451L-22.3819 25.4664C-16.7638 26.466 -5.5275 28.5086 5.6835 25.8575C16.9071 23.2065 28.0929 15.9052 39.3165 14.3406C50.5275 12.776 61.7637 16.9917 67.3819 19.0777L73 21.1856V49C40.2179 49 7.43585 49 -25.3475 49C-26.2312 49 -27.1163 49 -28 48L-9 28.3561Z'
	);
}
</style>
